import type { ApiResponse } from '@api/types/api-response';
import api from '.';
import { PRAYER_HUBS_GET_ONE_PUBLIC, PRAYER_HUBS_PUBLIC, PRAYER_HUBS_PUBLIC_CREATE } from '@api/constants/routes';
import { Params as GetOneParams, Result as GetOneResult } from '@api/routes/prayer-hubs/get-one/params';
import { Params as GetParams, Result as GetResult } from '@api/routes/prayer-hubs/get/params';
import { Params as CreateParams, Result as CreateResult } from '@api/routes/prayer-hubs/create/params';
import qs from 'qs';

export const prayerHubs = api.injectEndpoints({
  endpoints: builder => ({
    getPrayerHubs: builder.query<ApiResponse<GetResult>, GetParams>({
      query: params => {
        return {
          method: 'GET',
          url: `${PRAYER_HUBS_PUBLIC}?${qs.stringify(params)}`,
        };
      },
    }),
    getPrayerHub: builder.query<ApiResponse<GetOneResult>, GetOneParams>({
      query: params => {
        return {
          method: 'GET',
          url: `${PRAYER_HUBS_GET_ONE_PUBLIC}`.replace(':id', params.id),
        };
      },
    }),
    createHub: builder.mutation<ApiResponse<CreateResult>, CreateParams>({
      query: params => ({
        method: 'POST',
        url: PRAYER_HUBS_PUBLIC_CREATE,
        body: { ...params },
      }),
    }),
  }),
  overrideExisting: false,
});
